const TooltipContent = ({ label, description }) => (
  <div>
    <div style={{ fontWeight: 'bold' }}>{label}</div>
    {description && <div>Description: {description}</div>}
  </div>
);

export default TooltipContent;
